import React from 'react';
import { Reveal } from './ui/Reveal';
import { BONUS_TOTAL, bonuses } from '../data/content';

/* Mismos colores que los bonos en la imagen del pack */
const BONO_COLORS = ['bg-red-600 text-white', 'bg-purple-600 text-white', 'bg-green-600 text-white', 'bg-orange-500 text-white', 'bg-purple-700 text-white'];
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-white text-noche-dark" data-id="element-25" data-mp="qw5wdnh1i5we">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-26" data-mp="14rrk7rbjejn8">
        <h2 id="bonos" className="font-display text-3xl uppercase leading-none sm:text-5xl" data-id="element-27" data-mp="ztg5p3aarkyo">
          <span className="inline-block rounded-lg bg-noche px-2 py-1 text-oro" data-id="element-28" data-mp="1eim4wr94xb6k">
            🎁 5 Bonos incluidos
          </span>
        </h2>
        <p className="mx-auto mt-2.5 max-w-xl text-sm leading-snug text-noche-dark/80" data-id="element-29" data-mp="1njsnd5vcgw2g">
          Y además recibís 5 recursos prácticos —{' '}
          <strong className="font-extrabold text-verde-dark" data-id="element-30" data-mp="1jk1rwouvhrrl">
            GRATIS con tu compra.
          </strong>
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-31" data-mp="3pseng7wphcbn">
          {bonuses.map((bono, i) => <Reveal key={bono.title} as="li" delay={i * 0.03} className={`flex h-full flex-col overflow-hidden rounded-xl border-2 border-noche bg-ciencia-light text-left ${i === bonuses.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-32" data-mp="3tu00bt98pqlu" data-mpi={i}>
              <span className={`px-2.5 py-1 font-sub text-sm font-extrabold ${BONO_COLORS[i]}`} data-id="element-33" data-mp="gl5dhusrpnwt">
                Bono {i + 1} — Gratis
              </span>
              <div className="flex flex-1 flex-col p-2.5" data-id="element-34" data-mp="lcvps6b9mlqv">
                <h3 className="font-sub text-sm font-extrabold leading-tight text-noche" data-id="element-35" data-mp="qbgf3aozbl0j">
                  {bono.title}
                </h3>
                <p className="mt-0.5 text-xs leading-snug text-noche-dark/80 sm:text-sm" data-id="element-36" data-mp="vc4g8p6x9i8h">
                  {bono.desc}
                </p>
                <p className="mt-auto pt-1.5 text-xs font-bold text-noche-dark/80" data-id="element-37" data-mp="akz600dt70kr">
                  Valor:{' '}
                  <span className="text-red-600 line-through decoration-2" data-id="element-38" data-mp="5mxdkouhtowm">
                    {bono.value}
                  </span>
                </p>
              </div>
            </Reveal>)}
        </ul>

        <div className="mt-3 rounded-xl border-2 border-dashed border-oro bg-noche px-3 py-2.5 leading-tight" data-id="element-39" data-mp="fjjwh839e5w0">
          <p className="font-sub text-base font-bold text-white" data-id="element-40" data-mp="ta5jn8zqx1zp">
            💰 Valor total de los 5 bonos:{' '}
            <span className="text-white/80 line-through decoration-red-500 decoration-2" data-id="element-41" data-mp="oeq6kj9kba4c">
              {BONUS_TOTAL}
            </span>
          </p>
          <p className="mt-1 font-display text-lg uppercase text-oro sm:text-xl" data-id="element-42" data-mp="yajror1ckbxq">
            🔥 Hoy los 5 están incluidos gratis.
          </p>
        </div>
      </div>
    </section>;
}